import { useState, useContext, useEffect, useRef } from 'react'
import {
    Box,
    Card,
    Grid,
    Toolbar,
    IconButton,
    Button,
    useMediaQuery,
    useTheme,
    CircularProgress,
    Hidden,
    Divider,
    FormControl,
    InputLabel,
    ListItemButton,
    MenuItem,
    Select,
    Pagination,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    List,
    ListItem,
    ListItemText
} from '@mui/material'
import { ArrowBackIos } from '@mui/icons-material'
import { date, useStylesTheme } from '../../config'
import { useNavigate, useLocation } from 'react-router-dom'
/* import { machinesDatabase, reportsDatabase } from '../../indexedDB' */
import {
    useAuth,
    useUser,
    useReportsContext,
    useSitesContext,
    useExecutionReportContext,
    useConnectionContext
} from '../../context'
import SeleccionarObraDialog from '../../dialogs/SeleccionarObraDialog'
import { GenerationStatusModal } from '../../dialogs/StatusModal'
import { BulkActionDialog } from '../../dialogs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faEye,
    faMapMarker,
    faPen,
    faReply,
    faRepublican,
    faPlus,
    faClipboardList,
    faDownload,
    faFileExport,
    faCheckCircle,
    faCloudUploadAlt
} from '@fortawesome/free-solid-svg-icons'
import { executionReportsRoutes } from '../../routes'
import { ReportsList } from '../../containers'

const ActivitiesPage = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { userData } = useAuth()
    const { isOnline } = useConnectionContext()
    const {
        isOperator,
        isSapExecutive,
        isShiftManager,
        isChiefMachinery,
        admin,
        isSuperAdmin,
        isUniversalInspector,
        isUniversalChief,
        isOperatorInspector
    } = useUser()
    // const isUniversal = isUniversalInspector
    const isUniversal = false
    const {
        priorityAssignments,
        normalAssignments,
        siteSelected,
        setReport,
        waitReports,
        assignmentsError,
        getReports,
        updateLocalReport,
        reportesSeleccionados,
        reportsToShow,
        statusReports,
        totalReportsList,
        sortField,
        sortOrder,
        filtroReporte,
        valueFilter,
        setValueFilter
    } = useReportsContext()
    const { bulkSyncExecutionReports, bulkAssignReports, startReport } =
		useExecutionReportContext()
    const { sites } = useSitesContext()
    const [showList, setShowList] = useState(true)
    const theme = useTheme()
    const isSmall = useMediaQuery(theme.breakpoints.down('sm'))
    const [asignaciones, setAsignaciones] = useState('only')
    const [listadoReportes, setListadoReportes] = useState([])
    const [listadoReportesCache, setListadoReportesCache] = useState([])
    const [openSeleccionarObra, setOpnSeleccionarObra] = useState(false)
    const [loading, setLoading] = useState(false)
    const [order, setOrder] = useState(false)
    const [siteObject, setSiteObject] = useState()
    const [universalStateFilter, setUniversalStateFilter] = useState(
        isUniversal ? 'all' : 'Ejecutando por operador'
    )
    const [page, setPage] = useState(1)
    const rowsPerPage = 10
    const [totalPaginas, setTotalPaginas] = useState(0)
    const [reportsToShowMapped, setReportsToShowMapped] = useState([])
    const [selectedReports, setSelectedReports] = useState(new Map())
    const [openPrepareModal, setOpenPrepareModal] = useState(false)
    const [universalViewMode, setUniversalViewMode] = useState('all')

    const renderDateWithBreak = (dateVal) => {
        const formatted = date(dateVal)
        if (!formatted || formatted.toLowerCase() === 'sin información') {
            return (
                <>
					SIN<br />INFORMACIÓN
                </>
            )
        }
        const parts = formatted.split(' DE ')
        if (parts.length === 2) {
            return (
                <>
                    {parts[0]}<br />DE {parts[1]}
                </>
            )
        }
        return formatted
    }

    const renderFlotaWithBreak = (element) => {
        if (!element.maquina) {
            return (
                <>
					SIN<br />INFORMACIÓN
                </>
            )
        }
        const type = element.maquina.type || ''
        const model = element.maquina.model || ''
        if (
            type.toLowerCase() === 'sin información' ||
			model.toLowerCase() === 'sin información' ||
			(!type && !model)
        ) {
            return (
                <>
					SIN<br />INFORMACIÓN
                </>
            )
        }
        if (type && model) {
            return (
                <>
                    {type}<br />{model}
                </>
            )
        }
        return type || model
    }

    const [lastPreparedRefresh, setLastPreparedRefresh] = useState(0)
    const hasSetInitialViewMode = useRef(false)
    const debounceTimerRef = useRef(null)
    const abortControllerRef = useRef(null)

    const [tipoDeSeleccion, setTipoDeSeleccion] = useState(
        isUniversalInspector || isUniversalChief || isOperatorInspector
            ? 'listaSeleccionada'
            : 'global'
    )
    const [tipoDeBusqueda, setTipoDeBusqueda] = useState('')

    useEffect(() => {
        return () => {
            setValueFilter('')
        }
    }, [setValueFilter])

    useEffect(() => {
        if (
            isUniversal &&
			isOnline &&
			waitReports === false &&
			!hasSetInitialViewMode.current
        ) {
            setUniversalViewMode('all')
            hasSetInitialViewMode.current = true
        }
    }, [isUniversal, isOnline, waitReports])

    useEffect(() => {
        if (!isOnline && isUniversal) {
            setUniversalViewMode('local')
        }
    }, [isOnline, isUniversal])

    const handleSelectItem = (e, index) => {
        const report = reportsToShowMapped[index]
        if (!report) return

        setSelectedReports((prev) => {
            const next = new Map(prev)
            if (e.target.checked) {
                next.set(report._id, report)
            } else {
                next.delete(report._id)
            }
            return next
        })
    }

    const handleSelectAllItems = (checked) => {
        setSelectedReports((prev) => {
            const next = new Map(prev)
            reportsToShowMapped.forEach((r) => {
                if (checked) {
                    next.set(r._id, r)
                } else {
                    next.delete(r._id)
                }
            })
            return next
        })
    }

    const handleRemoveSelectedReport = (reportId) => {
        setSelectedReports((prev) => {
            const next = new Map(prev)
            next.delete(reportId)
            return next
        })
    }

    const handlePrepareOts = async () => {
        const reportIds = Array.from(selectedReports.keys())

        setOpenPrepareModal(false)
        await bulkAssignReports(reportIds)
        setSelectedReports(new Map())
        setUniversalViewMode('local')
    }

    const levelToState = (level, usersAssigned, state) => {
        if (level === 0 || !level) {
            if (usersAssigned && usersAssigned.length > 0) {
                if (state === 'En proceso') {
                    return 'Ejecutando por operador'
                }
                return 'Reasignar'
            } else {
                return state === 'Reasignar' ? 'Reasignar' : 'Asignar'
            }
        } else if (level === 1) {
            return 'Revisión Supervisor'
        } else if (level === 2) {
            return 'Revisión J. Maquinaria'
        } else if (level === 3) {
            return 'Revisión SAP'
        } else if (level === 4) {
            return 'Completada'
        }
    }

    useEffect(() => {
        setPage(1)
    }, [sortField, sortOrder])

    useEffect(() => {
        if (reportsToShow && reportsToShow.length > 0) {
            const mappedList = reportsToShow
                .filter((report) => {
                    if (!isOnline && !report.tieneEjecucionEnDispositivo) {
                        return false
                    }
                    // Si es universal, filtrar según el modo de vista (local o global)
                    if (isUniversal) {
                        if (universalViewMode === 'local') {
                            // En modo local solo mostrar los que tienen ejecución en el dispositivo
                            if (!report.tieneEjecucionEnDispositivo) {
                                return false
                            }
                        }
                    }
                    // OIU (isUniversalInspector) no debe ver los que están en revisión
                    if (isUniversalInspector) {
                        const level = report.level || 0
                        if (level > 0) {
                            return false
                        }
                    }
                    return true
                })
                .map((report) => {
                    const newReport = { ...report }

                    const currentUserId = userData?._id
                    const userHasStarted = report.ejecuciones?.some(
                        (e) =>
                            (e.userId?._id || e.userId)?.toString() ===
								currentUserId?.toString() && e.termino === null
                    )

                    if (isOperator && (!isUniversal || universalViewMode === 'local')) {
                        if (userHasStarted) {
                            newReport.estado = 'En curso'
                        } else if (report.progress === 100) {
                            newReport.estado = 'Listo'
                        } else {
                            newReport.estado = 'Disponible'
                        }
                    } else {
                        newReport.estado = levelToState(
                            report.level,
                            report.usersAssigned,
                            report.state
                        )
                    }

                    const isDownloaded = !!report.tieneEjecucionEnDispositivo

                    const bottomLabel = isDownloaded ? 'Descargada' : 'Disponible'
                    const bottomColor = isDownloaded ? '#4caf50' : '#856404'

                    if (isOperator && (!isUniversal || universalViewMode === 'local')) {
                        if (userHasStarted) {
                            newReport.estado = (
                                <div style={{ textAlign: 'center' }}>
									En curso
                                    {isDownloaded && (
                                        <>
                                            <br />
                                            <span
                                                style={{
                                                    fontSize: 10,
                                                    color: bottomColor,
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {bottomLabel}
                                            </span>
                                        </>
                                    )}
                                </div>
                            )
                        } else if (newReport.estado === 'Disponible' && !isDownloaded) {
                        } else if (typeof newReport.estado === 'string') {
                            newReport.estado = (
                                <div style={{ textAlign: 'center' }}>
                                    {newReport.estado}
                                    <br />
                                    <span
                                        style={{
                                            fontSize: 10,
                                            color: bottomColor,
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        {bottomLabel}
                                    </span>
                                </div>
                            )
                        }
                    } else if (report.tieneEjecucionEnDispositivo) {
                        if (userHasStarted && isOperator) {
                            newReport.estado = (
                                <span>
                                    <FontAwesomeIcon
                                        icon={faDownload}
                                        style={{ marginRight: 5, fontSize: 10 }}
                                    />
									En curso
                                </span>
                            )
                        } else {
                            newReport.estado = (
                                <span>
                                    <FontAwesomeIcon
                                        icon={faDownload}
                                        style={{ marginRight: 5, fontSize: 10 }}
                                    />
                                    {newReport.estado}
                                </span>
                            )
                        }
                    }

                    newReport.checked = selectedReports.has(report._id)
                    return newReport
                })
            setReportsToShowMapped(mappedList)
        } else {
            setReportsToShowMapped([])
        }
    }, [
        reportsToShow,
        selectedReports,
        isUniversal,
        isOperator,
        userData,
        universalViewMode,
        isUniversalInspector
    ])

    useEffect(() => {
        const isSearchActive = valueFilter.trim().length > 0 && tipoDeBusqueda !== ''
        if (!isSearchActive) {
            if (totalReportsList > 0) {
                setTotalPaginas(Math.ceil(totalReportsList / rowsPerPage))
            } else {
                setTotalPaginas(0)
            }
        }
    }, [totalReportsList, rowsPerPage, valueFilter, tipoDeBusqueda])

    const buscarReportesFiltrados = async (value) => {
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current)
        if (abortControllerRef.current) abortControllerRef.current.abort()

        abortControllerRef.current = new AbortController()

        debounceTimerRef.current = setTimeout(async () => {
            try {
                const numeroInicialPagina = (page - 1) * rowsPerPage
                const valueToSearch = value

                if (
                    tipoDeBusqueda === 'idIndex' &&
					valueToSearch !== '' &&
					!/^\d+$/.test(valueToSearch)
                )
                { return }

                console.log('[Activities] Executing search filter for:', valueToSearch)
                const typeToFetch =
					isUniversalInspector || isUniversalChief ? 'Inspección' : 'todos'

                const { numeroItems } = await filtroReporte(
                    tipoDeSeleccion === 'global' ? '' : universalStateFilter,
                    numeroInicialPagina,
                    rowsPerPage,
                    tipoDeSeleccion === 'global' ? '' : typeToFetch,
                    tipoDeSeleccion === 'global',
                    valueToSearch,
                    tipoDeBusqueda,
                    sortField || 'endReport',
                    sortOrder || -1,
                    abortControllerRef.current.signal
                )

                if (numeroItems !== null) {
                    setTotalPaginas(Math.ceil(numeroItems / rowsPerPage))
                }
            } catch (err) {
                if (err.name !== 'AbortError') {
                    console.error('Error en búsqueda:', err)
                }
            }
        }, 500)
    }

    useEffect(() => {
        if (isUniversal && siteObject && waitReports === false) {
            const val = valueFilter.trim()
            if (val.length > 0 && tipoDeBusqueda !== '') {
                buscarReportesFiltrados(val)
            } else {
                const safePage = Math.max(1, page)
                const typeToFetch =
					isUniversalInspector || isUniversalChief ? 'Inspección' : 'todos'

                reportesSeleccionados(
                    universalStateFilter,
                    (safePage - 1) * rowsPerPage,
                    rowsPerPage,
                    typeToFetch,
                    sortField,
                    sortOrder,
                    false
                )
            }
        }
    }, [
        isUniversal,
        siteObject,
        waitReports,
        universalStateFilter,
        page,
        valueFilter,
        tipoDeBusqueda,
        tipoDeSeleccion,
        sortField,
        sortOrder
    ])

    useEffect(() => {
        if (priorityAssignments.length > 0) {
            const mappedReports = priorityAssignments
                .filter((report) => {
                    // Si estamos offline, ocultar los que no tienen ejecución local
                    if (!isOnline && !report.tieneEjecucionEnDispositivo) {
                        return false
                    }
                    return true
                })
                .map((report) => {
                    const detailedReport = { ...report }

                    if (
                        detailedReport.usersAssigned &&
						detailedReport.usersAssigned.length > 0
                    ) {
                        detailedReport.asignadoA = detailedReport.usersAssigned[0]
                    }

                    if (
                        detailedReport.historialAsignaciones &&
						detailedReport.historialAsignaciones.length > 0
                    ) {
                        const lastHistory =
							detailedReport.historialAsignaciones[
							    detailedReport.historialAsignaciones.length - 1
							]
                        detailedReport.asignadoPor = lastHistory.asignadoPor
                    }

                    detailedReport.index = detailedReport.newIdIndex
                        ? detailedReport.newIdIndex
                        : detailedReport.idIndex
                    return detailedReport
                })

            setListadoReportes(mappedReports)
        } else {
            setListadoReportes([])
        }
    }, [priorityAssignments, normalAssignments, isOnline])

    useEffect(() => {
        if (sites.length > 0 && siteSelected) {
            const sId =
				typeof siteSelected === 'object'
				    ? siteSelected._id || siteSelected.idobra
				    : siteSelected
            if (sId === 'all') {
                setSiteObject({
                    _id: 'all',
                    idObra: 'none',
                    descripcion: 'Todas las obras'
                })
            } else if (sId === 'universal') {
                setSiteObject({
                    _id: 'universal',
                    idObra: 'universal',
                    descripcion: 'REPORTES UNIVERSALES'
                })
            } else {
                const siteFiltered = sites.find(
                    (site) => site._id === sId || site.idobra === sId
                )
                setSiteObject(siteFiltered)
            }
            if (isUniversal) {
                // setUniversalStateFilter('all') // no necesita cargar ya esta la persistencia
                setPage(1)
            }
        }
    }, [siteSelected, sites, isUniversal])

    const handleBulkDownload = () => {
        const reportIds = listadoReportes.map((r) => r._id)
        if (reportIds.length === 0) {
            alert('No hay pautas asignadas para descargar.')
            return
        }
        bulkSyncExecutionReports(reportIds, listadoReportes)
    }

    const handleReportAction = async (report) => {
        setReport(report)
        let finalExecutionReport = null

        const hasPermission =
			isOperator ||
			admin ||
			isSuperAdmin ||
			isShiftManager ||
			isChiefMachinery ||
			isUniversalInspector ||
			isUniversalChief ||
			isOperatorInspector
        console.log(
            `[Activities.page] Verificando permisos para OT ${report._id}. hasPermission: ${hasPermission}`
        )

        const shouldStartAutomatically =
			(isOperator || isOperatorInspector) && !isUniversal

        if (hasPermission && shouldStartAutomatically) {
            try {
                console.log(
                    `[Activities.page] Intentando iniciar/recuperar reporte para ID: ${report._id}`
                )
                finalExecutionReport = await startReport(report._id, report)
                console.log(
                    '[Activities.page] Reporte de ejecución procesado:',
                    finalExecutionReport
                )
            } catch (error) {
                console.error('[Activities.page] Error al iniciar reporte:', error)
                if (error.response?.status === 403) {
                    alert(
                        'No tiene permisos para iniciar o acceder a este reporte (No asignado).'
                    )
                    return
                }
            }
        } else if (hasPermission && isUniversal) {
            console.log(
                '[Activities.page] Universal role detected. Navigating to detail without starting clock.'
            )
        }

        console.log(
            '[Activities.page] Navegando a la página de detalle con executionReport:',
            finalExecutionReport
        )
        navigate(
            `/assignment/${report.newIdIndex ? report.newIdIndex : report.idIndex}`,
            { state: { executionReport: finalExecutionReport } }
        )
    }

    const compareBy = (value) => {
        console.log(value)
        if (order) {
            setOrder(false)
        } else {
            setOrder(true)
        }
        const listadoReportesCache2 = [...listadoReportesCache]
        if (value === 'ot') {
            setListadoReportes(listadoReportesCache2.sort(compareByOt))
        } else if (value === 'dateInit') {
            setListadoReportes(listadoReportesCache2.sort(compareInicio))
        } else if (value === 'datePrev') {
            setListadoReportes(listadoReportesCache2.sort(compareInicioProgramado))
        } else if (value === 'endPrev') {
            setListadoReportes(listadoReportesCache2.sort(compareTerminoProgramado))
        } else if (value === 'endReport') {
            setListadoReportes(listadoReportesCache2.sort(compareTermino))
        } else if (value === 'guia') {
            setListadoReportes(listadoReportesCache2.sort(compareByGuia))
        } else if (value === 'sap') {
            setListadoReportes(listadoReportesCache2.sort(compareBySAP))
        } else if (value === 'flota') {
            setListadoReportes(listadoReportesCache2.sort(compareFlota))
        } else if (value === 'progress') {
            setListadoReportes(listadoReportesCache2.sort(compareProgress))
        }
    }

    const compareByOt = (a, b) => {
        if (order) {
            return a.index - b.index
        } else {
            return b.index - a.index
        }
    }

    const compareByGuia = (a, b) => {
        if (order) {
            if (a.guide < b.guide) {
                return -1
            }
            if (a.guide > b.guide) {
                return 1
            }
            return 0
        } else {
            if (b.guide < a.guide) {
                return -1
            }
            if (b.guide > a.guide) {
                return 1
            }
            return 0
        }
    }

    const compareBySAP = (a, b) => {
        if (order) {
            return a.sapId - b.sapId
        } else {
            return b.sapId - a.sapId
        }
    }

    const compareFlota = (a, b) => {
        if (
            `${a.maquina && a.maquina.type} ${a.maquina && a.maquina.model}` <
			`${b.maquina && b.maquina.type} ${b.maquina && b.maquina.model}`
        ) {
            return -1
        }
        if (
            `${a.maquina && a.maquina.type} ${a.maquina && a.maquina.model}` >
			`${b.maquina && b.maquina.type} ${b.maquina && b.maquina.model}`
        ) {
            return 1
        }
        return 0
    }

    const compareInicio = (a, b) => {
        if (order) {
            return new Date(a.dateInit) - new Date(b.dateInit)
        } else {
            return new Date(b.dateInit) - new Date(a.dateInit)
        }
    }

    const compareInicioProgramado = (a, b) => {
        if (order) {
            return new Date(a.datePrev) - new Date(b.datePrev)
        } else {
            return new Date(b.datePrev) - new Date(a.datePrev)
        }
    }

    const compareTerminoProgramado = (a, b) => {
        if (order) {
            return new Date(a.endPrev) - new Date(b.endPrev)
        } else {
            return new Date(b.endPrev) - new Date(a.endPrev)
        }
    }

    const compareTermino = (a, b) => {
        if (order) {
            return new Date(a.endReport) - new Date(b.endReport)
        } else {
            return new Date(b.endReport) - new Date(a.endReport)
        }
    }

    const compareProgress = (a, b) => {
        if (order) {
            return a.progress - b.progress
        } else {
            return b.progress - a.progress
        }
    }

    useEffect(() => {
        if (asignaciones === 'only') {
            setListadoReportes(priorityAssignments)
            setListadoReportesCache(priorityAssignments)
        } else {
            /* setListadoReportes(normalAssignments)
            setListadoReportesCache(normalAssignments) */
        }
    }, [asignaciones])

    const closeSeleccionarObra = (value) => {
        if (value === 'Selected') {
            setLoading(true)
            setListadoReportes([])
        }
        setOpnSeleccionarObra(false)
    }
    const getReportBackgroundColor = (report, currentUserId) => {
        const hasOngoingExecutionByCurrentUser =
			report.ejecuciones &&
			report.ejecuciones.some(
			    (ejecucion) =>
			        (ejecucion.userId?._id || ejecucion.userId)?.toString() ===
						currentUserId?.toString() &&
					ejecucion.inicio &&
					ejecucion.termino === null
			)
        if (hasOngoingExecutionByCurrentUser) {
            return '#fafab4' // Amarillo: En curso
        }

        return '#fff' // Blanco: Disponible / Otros
    }

    return (
        <Box height="100%">
            {openSeleccionarObra && (
                <SeleccionarObraDialog
                    open={openSeleccionarObra}
                    handleClose={closeSeleccionarObra}
                />
            )}
            <Grid className={'root'} container spacing={0}>
                <Grid className={'pageContainer'} item xs={12}>
                    <Card elevation={0} className={'pageCard'} style={{ overflowY: 'hidden' }}>
                        <Grid container alignItems="center" justifyContent="center">
                            <div
                                className="navigation-bar"
                                style={{
                                    width: '100%',
                                    textAlign: 'left',
                                    boxSizing: 'border-box'
                                }}
                            >
                                <div
                                    style={{
                                        width: '100%',
                                        textAlign: 'left',
                                        color: '#333',
                                        backgroundColor: '#fff',
                                        borderRadius: 20
                                    }}
                                >
                                    <Toolbar
                                        style={{
                                            paddingLeft: 0,
                                            backgroundColor: '#F9F9F9',
                                            borderRadius: 10,
                                            width: '100%',
                                            boxSizing: 'border-box',
                                            flexWrap: 'wrap',
                                            height: 'auto',
                                            minHeight: '56px',
                                            paddingTop: '6px',
                                            paddingBottom: '6px'
                                        }}
                                    >
                                        <IconButton
                                            onClick={() =>
                                                setTimeout(() => {
                                                    navigate(-1)
                                                }, 500)
                                            }
                                        >
                                            <ArrowBackIos style={{ color: '#333', fontSize: 16 }} />
                                        </IconButton>
                                        <h1
                                            style={{
                                                marginTop: 0,
                                                marginBottom: 0,
                                                fontSize: 16,
                                                flexGrow: 1
                                            }}
                                        >
                                            {isUniversal
                                                ? universalViewMode === 'all'
                                                    ? 'Actividades en curso'
                                                    : 'Pautas preparadas'
                                                : 'Actividades Asignadas'}
                                        </h1>
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexWrap: 'wrap',
                                                gap: '10px',
                                                marginRight: '10px',
                                                justifyContent: 'flex-end'
                                            }}
                                        >
                                            {isUniversal && isOnline && (
                                                <Button
                                                    variant="contained"
                                                    color={
                                                        universalViewMode === 'local'
                                                            ? 'secondary'
                                                            : 'primary'
                                                    }
                                                    onClick={async () => {
                                                        const nextMode =
															universalViewMode === 'all' ? 'local' : 'all'
                                                        setUniversalViewMode(nextMode)

                                                        if (nextMode === 'local' && isOnline) {
                                                            const now = Date.now()
                                                            const shouldRefresh =
																now - lastPreparedRefresh > 300000 ||
																priorityAssignments.length === 0

                                                            if (shouldRefresh) {
                                                                try {
                                                                    setLoading(true)
                                                                    await getReports()
                                                                    setLastPreparedRefresh(now)
                                                                } catch (error) {
                                                                    console.error(
                                                                        'Error refrescando pautas preparadas:',
                                                                        error
                                                                    )
                                                                } finally {
                                                                    setLoading(false)
                                                                }
                                                            }
                                                        }
                                                    }}
                                                    startIcon={
                                                        <FontAwesomeIcon
                                                            icon={
                                                                universalViewMode === 'all'
                                                                    ? faClipboardList
                                                                    : faReply
                                                            }
                                                        />
                                                    }
                                                    style={{ textTransform: 'none', fontWeight: 'bold' }}
                                                >
                                                    {universalViewMode === 'all'
                                                        ? 'Ver Pautas Preparadas'
                                                        : 'Ver Actividades'}
                                                </Button>
                                            )}

                                            {isUniversal &&
												universalViewMode === 'local' &&
												isOnline && (
                                                <IconButton
                                                    color={'primary'}
                                                    onClick={handleBulkDownload}
                                                    title="Descargar pautas para offline"
                                                >
                                                    <FontAwesomeIcon icon={faDownload} />
                                                </IconButton>
                                            )}

                                            {isUniversal &&
												universalViewMode === 'all' &&
												isOnline && (
                                                <div style={{ width: 300, marginRight: 10 }}>
                                                    <Grid
                                                        style={{ position: 'relative', width: '100%' }}
                                                        container
                                                    >
                                                        <Grid item xs={5}>
                                                            <div style={{ padding: '0px 5px' }}>
                                                                <select
                                                                    disabled={tipoDeSeleccion.length === 0}
                                                                    value={tipoDeBusqueda}
                                                                    onChange={(e) => {
                                                                        setTipoDeBusqueda(e.target.value)
                                                                    }}
                                                                    style={{ height: 24, width: '100%' }}
                                                                    placeholder="Tipo Selección"
                                                                >
                                                                    <option value="">Tipo Búsqueda</option>
                                                                    <option value={'idIndex'}>N° OT</option>
                                                                    <option value={'maquina'}>Maquina</option>
                                                                    <option value={'sap'}>SAP ID</option>
                                                                </select>
                                                            </div>
                                                        </Grid>
                                                        <Grid item xs={7}>
                                                            <input
                                                                disabled={tipoDeBusqueda.length === 0}
                                                                style={{ height: 24, width: '100%' }}
                                                                value={valueFilter}
                                                                onChange={(e) => {
                                                                    const val = e.target.value
                                                                    setValueFilter(val)
                                                                    setPage(1)
                                                                }}
                                                                placeholder="Filtrar Reporte"
                                                                type="search"
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            )}

                                            {isUniversal &&
												universalViewMode === 'all' &&
												isOnline && (
                                                <FormControl size="small" style={{ minWidth: 140 }}>
                                                    <InputLabel
                                                        id="state-select-label"
                                                        color={'primary'}
                                                    >
															Estado
                                                    </InputLabel>
                                                    <Select
                                                        color={'primary'}
                                                        labelId="state-select-label"
                                                        id="state-select"
                                                        value={universalStateFilter}
                                                        label="Estado"
                                                        onChange={(e) => {
                                                            setUniversalStateFilter(e.target.value)
                                                            setValueFilter('')
                                                            setTipoDeBusqueda('')
                                                            setPage(1)
                                                        }}
                                                    >
                                                        <MenuItem value={'all'}>Todos</MenuItem>
                                                        <MenuItem value={'Ejecutando por operador'}>
																Ejecutando por operador
                                                        </MenuItem>
                                                        <MenuItem value={'Asignar'}>Asignar</MenuItem>
                                                        <MenuItem value={'Reasignar'}>Reasignar</MenuItem>
                                                        <MenuItem value={'Origen'}>Origen</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            )}

                                            {admin && siteObject && (
                                                <p
                                                    style={{
                                                        margin: 0,
                                                        textAlign: 'right',
                                                        maxWidth: 300,
                                                        color: '#666',
                                                        fontSize: 12
                                                    }}
                                                >
													Obra seleccionada: <br />
                                                    <strong>{siteObject.descripcion}</strong>
                                                </p>
                                            )}

                                            {/* {isUniversalInspector && isOnline && (
                                                <IconButton
                                                    color={'primary'}
                                                    onClick={() => {
                                                        navigate('/reports/create-report')
                                                    }}
                                                    title="Nuevo reporte"
                                                >
                                                    <div style={{ position: 'relative' }}>
                                                        <FontAwesomeIcon
                                                            style={{
                                                                position: 'absolute',
                                                                zIndex: 100,
                                                                fontSize: 10,
                                                                top: -4,
                                                                right: -6,
                                                                color: '#F78E63',
                                                                fontWeight: 600
                                                            }}
                                                            icon={faPlus}
                                                        />
                                                        <FontAwesomeIcon
                                                            style={{ zIndex: 10 }}
                                                            icon={faClipboardList}
                                                        />
                                                    </div>
                                                </IconButton>
                                            )} */}

                                            {isUniversal &&
												universalViewMode === 'all' &&
												isOnline && (
                                                <IconButton
                                                    color={'primary'}
                                                    onClick={() => setOpenPrepareModal(true)}
                                                    disabled={selectedReports.size === 0}
                                                    title="Preparar OTs"
                                                >
                                                    <div style={{ position: 'relative' }}>
                                                        {selectedReports.size > 0 && (
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: -10,
                                                                    right: -10,
                                                                    backgroundColor: '#F78E63',
                                                                    color: 'white',
                                                                    borderRadius: '50%',
                                                                    width: 18,
                                                                    height: 18,
                                                                    fontSize: 10,
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    fontWeight: 'bold',
                                                                    zIndex: 100
                                                                }}
                                                            >
                                                                {selectedReports.size}
                                                            </div>
                                                        )}
                                                        <FontAwesomeIcon icon={faFileExport} />
                                                    </div>
                                                </IconButton>
                                            )}

                                            {!isUniversal && (
                                                <IconButton
                                                    color={'primary'}
                                                    onClick={handleBulkDownload}
                                                    title="Descargar pautas"
                                                >
                                                    <FontAwesomeIcon icon={faDownload} />
                                                </IconButton>
                                            )}

                                            {(admin || isUniversalChief) &&
												isOnline && (
                                                <IconButton
                                                    color={'primary'}
                                                    onClick={() => setOpnSeleccionarObra(true)}
                                                    title="Seleccionar Obra"
                                                >
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', lineHeight: 1 }}>
                                                        <FontAwesomeIcon icon={faMapMarker} />
                                                        {siteObject && (siteObject.idAfa || siteObject.idObraAlfa || siteObject.idObra || siteObject.idobra) && (siteObject.idObra !== 'none' && siteObject.idobra !== 'none') && (
                                                            <span style={{ fontSize: '9px', marginTop: '2px', fontWeight: 'bold' }}>
                                                                {siteObject.idAfa || siteObject.idObraAlfa || siteObject.idObra || siteObject.idobra}
                                                            </span>
                                                        )}
                                                    </div>
                                                </IconButton>
                                            )}
                                        </div>
                                    </Toolbar>
                                </div>
                            </div>
                        </Grid>
                        <Grid container>
                            <div
                                style={{
                                    width: '100%',
                                    padding: '0px 10px',
                                    boxSizing: 'border-box'
                                }}
                            >
                                {isUniversal && universalViewMode === 'all' && isOnline ? (
                                    <div
                                        style={{
                                            height: 'calc(100vh - 190px)',
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}
                                    >
                                        <div style={{ flexGrow: 1, overflow: 'hidden' }}>
                                            <ReportsList
                                                list={reportsToShowMapped || []}
                                                typeReportsSelected={universalStateFilter}
                                                statusReports={statusReports}
                                                tipo="Inspección"
                                                setAllItemsSelected={handleSelectAllItems}
                                                allItemsSelected={
                                                    selectedReports.size > 0 &&
													reportsToShowMapped.every((r) =>
													    selectedReports.has(r._id)
													)
                                                }
                                                selectItem={handleSelectItem}
                                                onExecuteOverride={handleReportAction}
                                                canSelect={isUniversal || admin || isSuperAdmin}
                                            />
                                        </div>
                                        {reportsToShowMapped && reportsToShowMapped.length > 0 && (
                                            <div
                                                style={{
                                                    padding: '10px 0',
                                                    display: 'flex',
                                                    justifyContent: 'flex-end'
                                                }}
                                            >
                                                <Pagination
                                                    color={'primary'}
                                                    count={totalPaginas}
                                                    defaultPage={page}
                                                    page={page}
                                                    onChange={(e, p) => setPage(p)}
                                                />
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <>
                                        {waitReports ? (
                                            <p>Esperando descarga de reportes...</p>
                                        ) : assignmentsError ? (
                                            <div
                                                style={{
                                                    padding: '20px',
                                                    color: '#000000ff',
                                                    textAlign: 'center',
                                                    border: '1px solid #000000ff',
                                                    borderRadius: '8px',
                                                    margin: '20px'
                                                }}
                                            >
                                                <h4>{assignmentsError}</h4>
                                            </div>
                                        ) : listadoReportes.length === 0 ? (
                                            <p>Sin Ordenes de trabajo por revisar.</p>
                                        ) : (
                                            showList && (
                                                <Grid
                                                    container
                                                    style={{
                                                        overflowY: 'auto',
                                                        maxHeight: 'max(350px, calc(100vh - 295px))'
                                                    }}
                                                >
                                                    <Hidden mdDown>
                                                        <div
                                                            style={{
                                                                width: '100%',
                                                                borderRadius: 10,
                                                                borderStyle: 'solid',
                                                                borderWidth: 1,
                                                                borderColor: '#CCC',
                                                                backgroundColor: '#CCC',
                                                                marginBottom: 10,
                                                                position: 'sticky',
                                                                top: 0,
                                                                zIndex: 10
                                                            }}
                                                        >
                                                            <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                                                                <div style={{ width: '4%', display: 'flex', justifyContent: 'center' }}>
                                                                    <ListItemButton
                                                                        onClick={() => {
                                                                            compareBy('ot')
                                                                        }}
                                                                        style={{
                                                                            width: '100%',
                                                                            textAlign: 'center',
                                                                            padding: 0,
                                                                            margin: '12px 0px'
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                width: '100%',
                                                                                fontSize: 12,
                                                                                fontWeight: 'bold',
                                                                                margin: 0
                                                                            }}
                                                                        >
																			N° OT
                                                                        </p>
                                                                    </ListItemButton>
                                                                </div>
                                                                <div style={{ width: '5%', display: 'flex', justifyContent: 'center' }}>
                                                                    <ListItemButton
                                                                        onClick={() => {
                                                                            compareBy('guia')
                                                                        }}
                                                                        style={{
                                                                            width: '100%',
                                                                            textAlign: 'center',
                                                                            padding: 0,
                                                                            margin: '12px 0px'
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                width: '100%',
                                                                                fontSize: 12,
                                                                                fontWeight: 'bold',
                                                                                margin: 0
                                                                            }}
                                                                        >
																			Guía
                                                                        </p>
                                                                    </ListItemButton>
                                                                </div>
                                                                <div style={{ width: '6%', display: 'flex', justifyContent: 'center' }}>
                                                                    <ListItemButton
                                                                        onClick={() => {
                                                                            compareBy('sap')
                                                                        }}
                                                                        style={{
                                                                            width: '100%',
                                                                            textAlign: 'center',
                                                                            padding: 0,
                                                                            margin: '12px 0px'
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                width: '100%',
                                                                                fontSize: 12,
                                                                                fontWeight: 'bold',
                                                                                margin: 0
                                                                            }}
                                                                        >
																			SAP ID
                                                                        </p>
                                                                    </ListItemButton>
                                                                </div>
                                                                <div style={{ width: '9%', display: 'flex', justifyContent: 'center' }}>
                                                                    <ListItemButton
                                                                        onClick={() => {
                                                                            compareBy('datePrev')
                                                                        }}
                                                                        style={{
                                                                            width: '100%',
                                                                            padding: 0,
                                                                            margin: '12px 0px'
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                fontSize: 12,
                                                                                fontWeight: 'bold',
                                                                                width: '100%',
                                                                                margin: 0,
                                                                                textAlign: 'center'
                                                                            }}
                                                                        >
																			Inicio <br /> programado
                                                                        </p>
                                                                    </ListItemButton>
                                                                </div>
                                                                <div style={{ width: '9%', display: 'flex', justifyContent: 'center' }}>
                                                                    <ListItemButton
                                                                        onClick={() => {
                                                                            compareBy('dateInit')
                                                                        }}
                                                                        style={{
                                                                            width: '100%',
                                                                            padding: 0,
                                                                            margin: '12px 0px'
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                fontSize: 12,
                                                                                fontWeight: 'bold',
                                                                                width: '100%',
                                                                                margin: 0,
                                                                                textAlign: 'center'
                                                                            }}
                                                                        >
																			Inicio <br /> ejecución
                                                                        </p>
                                                                    </ListItemButton>
                                                                </div>
                                                                <div style={{ width: '9%', display: 'flex', justifyContent: 'center' }}>
                                                                    <ListItemButton
                                                                        onClick={() => {
                                                                            compareBy('endPrev')
                                                                        }}
                                                                        style={{
                                                                            width: '100%',
                                                                            padding: 0,
                                                                            margin: '12px 0px'
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                fontSize: 12,
                                                                                fontWeight: 'bold',
                                                                                width: '100%',
                                                                                margin: 0,
                                                                                textAlign: 'center'
                                                                            }}
                                                                        >
																			Término <br /> programado
                                                                        </p>
                                                                    </ListItemButton>
                                                                </div>
                                                                <div style={{ width: '9%', display: 'flex', justifyContent: 'center' }}>
                                                                    <ListItemButton
                                                                        onClick={() => {
                                                                            compareBy('endReport')
                                                                        }}
                                                                        style={{
                                                                            width: '100%',
                                                                            padding: 0,
                                                                            margin: '12px 0px'
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                fontSize: 12,
                                                                                fontWeight: 'bold',
                                                                                width: '100%',
                                                                                margin: 0,
                                                                                textAlign: 'center'
                                                                            }}
                                                                        >
																			Término <br /> ejecución
                                                                        </p>
                                                                    </ListItemButton>
                                                                </div>
                                                                <div style={{ width: '10%', display: 'flex', justifyContent: 'center' }}>
                                                                    <ListItemButton
                                                                        onClick={() => {
                                                                            compareBy('flota')
                                                                        }}
                                                                        style={{
                                                                            width: '100%',
                                                                            textAlign: 'center',
                                                                            padding: 0,
                                                                            margin: '12px 0px'
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                fontSize: 12,
                                                                                fontWeight: 'bold',
                                                                                textAlign: 'center',
                                                                                width: '100%',
                                                                                margin: 0
                                                                            }}
                                                                        >
																			Flota
                                                                        </p>
                                                                    </ListItemButton>
                                                                </div>
                                                                <div style={{ width: '8%', display: 'flex', justifyContent: 'center' }}>
                                                                    <ListItemButton
                                                                        onClick={() => {
                                                                            compareBy('progress')
                                                                        }}
                                                                        style={{
                                                                            width: '100%',
                                                                            textAlign: 'center',
                                                                            padding: 0,
                                                                            margin: '12px 0px',
                                                                            opacity: 1
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                fontSize: 12,
                                                                                fontWeight: 'bold',
                                                                                textAlign: 'center',
                                                                                width: '100%',
                                                                                margin: 0
                                                                            }}
                                                                        >
                                                                            {' '}
																			Progreso{' '}
                                                                        </p>
                                                                    </ListItemButton>
                                                                </div>
                                                                <div style={{ width: '8%', display: 'flex', justifyContent: 'center' }}>
                                                                    <ListItemButton
                                                                        disabled
                                                                        style={{
                                                                            width: '100%',
                                                                            textAlign: 'center',
                                                                            padding: 0,
                                                                            margin: '12px 0px',
                                                                            opacity: 1
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                fontSize: 12,
                                                                                fontWeight: 'bold',
                                                                                textAlign: 'center',
                                                                                width: '100%',
                                                                                margin: 0
                                                                            }}
                                                                        >
																			Nro Máquina
                                                                        </p>
                                                                    </ListItemButton>
                                                                </div>
                                                                <div style={{ width: '8%', display: 'flex', justifyContent: 'center' }}>
                                                                    <ListItemButton
                                                                        disabled
                                                                        style={{
                                                                            width: '100%',
                                                                            textAlign: 'center',
                                                                            padding: 0,
                                                                            margin: '12px 0px',
                                                                            opacity: 1
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                fontSize: 12,
                                                                                fontWeight: 'bold',
                                                                                textAlign: 'center',
                                                                                width: '100%',
                                                                                margin: 0
                                                                            }}
                                                                        >
																			Estado
                                                                        </p>
                                                                    </ListItemButton>
                                                                </div>
                                                                <div style={{ width: '8%', display: 'flex', justifyContent: 'center' }}>
                                                                    <ListItemButton
                                                                        disabled
                                                                        style={{
                                                                            width: '100%',
                                                                            textAlign: 'center',
                                                                            padding: 0,
                                                                            margin: '12px 0px',
                                                                            opacity: 1
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                fontSize: 12,
                                                                                fontWeight: 'bold',
                                                                                textAlign: 'center',
                                                                                width: '100%',
                                                                                margin: 0
                                                                            }}
                                                                        >
																			Contiene Doc.
                                                                        </p>
                                                                    </ListItemButton>
                                                                </div>
                                                                <div style={{ width: '7%', display: 'flex', justifyContent: 'center' }}>
                                                                    <ListItemButton
                                                                        disabled
                                                                        style={{
                                                                            textAlign: 'center',
                                                                            width: '100%',
                                                                            padding: 0,
                                                                            margin: '12px 0px',
                                                                            color: 'black',
                                                                            opacity: 1
                                                                        }}
                                                                    >
                                                                        <p
                                                                            style={{
                                                                                fontSize: 12,
                                                                                fontWeight: 'bold',
                                                                                width: '100%',
                                                                                marginRight: 0,
                                                                                color: 'black',
                                                                                margin: 0
                                                                            }}
                                                                        >
																			Acción
                                                                        </p>
                                                                    </ListItemButton>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Hidden>
                                                    {listadoReportes.map((element, i) => {
                                                        return (
                                                            <div
                                                                key={i}
                                                                style={{
                                                                    width: '100%',
                                                                    borderRadius: 10,
                                                                    borderStyle: 'solid',
                                                                    borderWidth: 1,
                                                                    borderColor: element.readyToSend
                                                                        ? '#be2e26'
                                                                        : '#cccccc',
                                                                    marginBottom: 10,
                                                                    backgroundColor: getReportBackgroundColor(
                                                                        element,
                                                                        userData._id
                                                                    )
                                                                }}
                                                            >
                                                                <Hidden mdUp>
                                                                    <Grid container>
                                                                        <Grid
                                                                            item
                                                                            xl={'auto'}
                                                                            lg={'auto'}
                                                                            md={'auto'}
                                                                            sm={3}
                                                                            xs={3}
                                                                        >
                                                                            <Hidden mdUp>
                                                                                <div style={{ padding: '0px 10px' }}>
                                                                                    <p style={{ fontSize: 11 }}>
																					OT:{' '}
                                                                                        {element.newIdIndex
                                                                                            ? element.newIdIndex
                                                                                            : element.idIndex}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                            <Hidden mdDown>
                                                                                <div
                                                                                    style={{
                                                                                        width: '4%',
                                                                                        textAlign: 'center'
                                                                                    }}
                                                                                >
                                                                                    <p style={{ fontSize: 11 }}>
                                                                                        {element.newIdIndex
                                                                                            ? element.newIdIndex
                                                                                            : element.idIndex}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                        </Grid>
                                                                        <Grid
                                                                            item
                                                                            xl={'auto'}
                                                                            lg={'auto'}
                                                                            md={'auto'}
                                                                            sm={4}
                                                                            xs={4}
                                                                        >
                                                                            <Hidden mdUp>
                                                                                <div style={{ padding: '0px 10px' }}>
                                                                                    <p style={{ fontSize: 11 }}>
																					Guía: {element._guide}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                            <Hidden mdDown>
                                                                                <div
                                                                                    style={{
                                                                                        width: '5%',
                                                                                        textAlign: 'center'
                                                                                    }}
                                                                                >
                                                                                    <p style={{ fontSize: 11 }}>
                                                                                        {element._guide}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                        </Grid>
                                                                        <Grid
                                                                            item
                                                                            xl={'auto'}
                                                                            lg={'auto'}
                                                                            md={'auto'}
                                                                            sm={5}
                                                                            xs={5}
                                                                        >
                                                                            <Hidden mdUp>
                                                                                <div style={{ padding: '0px 10px' }}>
                                                                                    <p style={{ fontSize: 11 }}>
																					SAP: {element.sapId}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                            <Hidden mdDown>
                                                                                <div
                                                                                    style={{
                                                                                        textAlign: 'center',
                                                                                        width: '6%'
                                                                                    }}
                                                                                >
                                                                                    <p style={{ fontSize: 11 }}>
                                                                                        {element.sapId}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                        </Grid>
                                                                        <Hidden mdUp>
                                                                            <Divider />
                                                                        </Hidden>
                                                                        <Grid
                                                                            item
                                                                            xl={'auto'}
                                                                            lg={'auto'}
                                                                            md={'auto'}
                                                                            sm={6}
                                                                            xs={6}
                                                                        >
                                                                            <Hidden mdUp>
                                                                                <div style={{ padding: '0px 10px' }}>
                                                                                    <p style={{ fontSize: 11 }}>
																					Fecha prevista:
                                                                                        <br /> {date(element.datePrev)}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                            <Hidden mdDown>
                                                                                <div
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        textAlign: 'left'
                                                                                    }}
                                                                                >
                                                                                    <p
                                                                                        style={{ fontSize: 11, width: '8%' }}
                                                                                    >
                                                                                        {date(element.datePrev)}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                        </Grid>
                                                                        <Grid
                                                                            item
                                                                            xl={'auto'}
                                                                            lg={'auto'}
                                                                            md={'auto'}
                                                                            sm={6}
                                                                            xs={6}
                                                                        >
                                                                            <Hidden mdUp>
                                                                                <div style={{ padding: '0px 10px' }}>
                                                                                    <p style={{ fontSize: 11 }}>
																					Fecha inicio: <br />
                                                                                        {date(element.dateInit)}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                            <Hidden mdDown>
                                                                                <div
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        textAlign: 'left'
                                                                                    }}
                                                                                >
                                                                                    <p
                                                                                        style={{ fontSize: 11, width: '8%' }}
                                                                                    >
                                                                                        {date(element.dateInit)}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                        </Grid>
                                                                        <Hidden mdDown>
                                                                            <Grid
                                                                                item
                                                                                xl={'auto'}
                                                                                lg={'auto'}
                                                                                md={'auto'}
                                                                                sm={'auto'}
                                                                                xs={'auto'}
                                                                            >
                                                                                <p style={{ fontSize: 11, width: '8%' }}>
                                                                                    {' '}
                                                                                    {date(element.endPrev)}{' '}
                                                                                </p>
                                                                            </Grid>
                                                                            <Grid
                                                                                item
                                                                                xl={'auto'}
                                                                                lg={'auto'}
                                                                                md={'auto'}
                                                                                sm={'auto'}
                                                                                xs={'auto'}
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        textAlign: 'left'
                                                                                    }}
                                                                                >
                                                                                    <p
                                                                                        style={{ fontSize: 11, width: '8%' }}
                                                                                    >
                                                                                        {date(element.endReport)}
                                                                                    </p>
                                                                                </div>
                                                                            </Grid>
                                                                        </Hidden>
                                                                        <Grid
                                                                            item
                                                                            xl={'auto'}
                                                                            lg={'auto'}
                                                                            md={'auto'}
                                                                            sm={12}
                                                                            xs={12}
                                                                        >
                                                                            <Hidden mdUp>
                                                                                <div style={{ padding: '0px 10px' }}>
                                                                                    <p
                                                                                        style={{
                                                                                            fontSize: 11,
                                                                                            textAlign: 'left'
                                                                                        }}
                                                                                    >
																					Flota:{' '}
                                                                                        {element.maquina &&
																						element.maquina.type}{' '}
                                                                                        {element.maquina &&
																						element.maquina.model}{' '}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                            <Hidden mdDown>
                                                                                <div
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        textAlign: 'left'
                                                                                    }}
                                                                                >
                                                                                    <p
                                                                                        style={{
                                                                                            fontSize: 11,
                                                                                            textAlign: 'left',
                                                                                            width: '9%'
                                                                                        }}
                                                                                    >
                                                                                        {' '}
                                                                                        {element.maquina &&
																						element.maquina.type}{' '}
                                                                                        {element.maquina &&
																						element.maquina.model}{' '}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                        </Grid>
                                                                        <Hidden mdUp>
                                                                            <Divider />
                                                                        </Hidden>
                                                                        <Grid
                                                                            item
                                                                            xl={'auto'}
                                                                            lg={'auto'}
                                                                            md={'auto'}
                                                                            sm={6}
                                                                            xs={6}
                                                                        >
                                                                            <Hidden mdUp>
                                                                                <div style={{ padding: '0px 10px' }}>
                                                                                    <p
                                                                                        style={{
                                                                                            fontSize: 11,
                                                                                            textAlign: 'left'
                                                                                        }}
                                                                                    >
																					Progreso:{' '}
                                                                                        {element.progress
                                                                                            ? `${element.progress}%`
                                                                                            : 'S/I'}{' '}
                                                                                    </p>
                                                                                    <p
                                                                                        style={{
                                                                                            fontSize: 11,
                                                                                            textAlign: 'left',
                                                                                            margin: '4px 0px 0px 0px'
                                                                                        }}
                                                                                    >
																					Doc. técnica: <strong>{element.hasTechnicalDocs ? 'Sí' : 'No'}</strong>
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                            <Hidden mdDown>
                                                                                <div
                                                                                    style={{
                                                                                        width: '8%',
                                                                                        textAlign: 'center'
                                                                                    }}
                                                                                >
                                                                                    <p
                                                                                        style={{
                                                                                            fontSize: 11,
                                                                                            textAlign: 'center',
                                                                                            width: '8%'
                                                                                        }}
                                                                                    >
                                                                                        {' '}
                                                                                        {element.progress
                                                                                            ? `${element.progress}%`
                                                                                            : 'S/I'}{' '}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                        </Grid>
                                                                        <Grid
                                                                            item
                                                                            xl={'auto'}
                                                                            lg={'auto'}
                                                                            md={'auto'}
                                                                            sm={6}
                                                                            xs={6}
                                                                        >
                                                                            <Hidden mdUp>
                                                                                <div style={{ padding: '0px 10px' }}>
                                                                                    <p
                                                                                        style={{
                                                                                            fontSize: 11,
                                                                                            textAlign: 'center'
                                                                                        }}
                                                                                    >
																					Máquina N°:{' '}
                                                                                        {element.maquina &&
																						element.maquina.equ}{' '}
                                                                                    </p>
                                                                                    {(() => {
                                                                                        const isDownloaded =
																						!!element.tieneEjecucionEnDispositivo
                                                                                        const hasOngoing =
																						element.ejecuciones &&
																						element.ejecuciones.some(
																						    (ej) =>
																						        (
																						            ej.userId?._id || ej.userId
																						        )?.toString() ===
																									userData?._id &&
																								ej.inicio &&
																								ej.termino === null
																						)

                                                                                        const bottomText = isDownloaded
                                                                                            ? 'Descargada'
                                                                                            : 'Disponible'
                                                                                        const bottomColor = isDownloaded
                                                                                            ? '#4caf50'
                                                                                            : '#856404'

                                                                                        if (hasOngoing) {
                                                                                            return (
                                                                                                <p
                                                                                                    style={{
                                                                                                        fontSize: 10,
                                                                                                        fontWeight: 'bold',
                                                                                                        color: '#856404',
                                                                                                        textAlign: 'center',
                                                                                                        margin: 0
                                                                                                    }}
                                                                                                >
																								En curso <br />
                                                                                                    <span
                                                                                                        style={{
                                                                                                            color: bottomColor
                                                                                                        }}
                                                                                                    >
                                                                                                        {bottomText}
                                                                                                    </span>
                                                                                                </p>
                                                                                            )
                                                                                        }
                                                                                        if (element.progress === 100) {
                                                                                            return (
                                                                                                <p
                                                                                                    style={{
                                                                                                        fontSize: 10,
                                                                                                        fontWeight: 'bold',
                                                                                                        color: '#155724',
                                                                                                        textAlign: 'center',
                                                                                                        margin: 0
                                                                                                    }}
                                                                                                >
																								Listo <br />
                                                                                                    <span
                                                                                                        style={{
                                                                                                            color: bottomColor
                                                                                                        }}
                                                                                                    >
                                                                                                        {bottomText}
                                                                                                    </span>
                                                                                                </p>
                                                                                            )
                                                                                        }
                                                                                        return (
                                                                                            <p
                                                                                                style={{
                                                                                                    fontSize: 10,
                                                                                                    color: '#666',
                                                                                                    textAlign: 'center',
                                                                                                    margin: 0
                                                                                                }}
                                                                                            >
																							Disponible
                                                                                                {isDownloaded && (
                                                                                                    <>
                                                                                                        <br />
                                                                                                        <span
                                                                                                            style={{
                                                                                                                color: bottomColor,
                                                                                                                fontWeight: 'bold'
                                                                                                            }}
                                                                                                        >
                                                                                                            {bottomText}
                                                                                                        </span>
                                                                                                    </>
                                                                                                )}
                                                                                            </p>
                                                                                        )
                                                                                    })()}
                                                                                </div>
                                                                            </Hidden>
                                                                            <Hidden mdDown>
                                                                                <div
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        textAlign: 'left'
                                                                                    }}
                                                                                >
                                                                                    <p
                                                                                        style={{
                                                                                            fontSize: 11,
                                                                                            textAlign: 'center',
                                                                                            width: '8%'
                                                                                        }}
                                                                                    >
                                                                                        {' '}
																					N°:{' '}
                                                                                        {element.maquina &&
																						element.maquina.equ}{' '}
                                                                                    </p>
                                                                                </div>
                                                                            </Hidden>
                                                                        </Grid>
                                                                        <Hidden mdDown>
                                                                            <Grid
                                                                                item
                                                                                xl={'auto'}
                                                                                lg={'auto'}
                                                                                md={'auto'}
                                                                                sm={'auto'}
                                                                                xs={'auto'}
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        width: '8%',
                                                                                        textAlign: 'center'
                                                                                    }}
                                                                                >
                                                                                    {(() => {
                                                                                        const isDownloaded =
																						!!element.tieneEjecucionEnDispositivo
                                                                                        const hasOngoing =
																						element.ejecuciones &&
																						element.ejecuciones.some(
																						    (ej) =>
																						        (
																						            ej.userId?._id || ej.userId
																						        )?.toString() ===
																									userData?._id &&
																								ej.inicio &&
																								ej.termino === null
																						)

                                                                                        const bottomText = isDownloaded
                                                                                            ? 'Descargada'
                                                                                            : 'Disponible'
                                                                                        const bottomColor = isDownloaded
                                                                                            ? '#4caf50'
                                                                                            : '#856404'

                                                                                        if (hasOngoing) {
                                                                                            return (
                                                                                                <p
                                                                                                    style={{
                                                                                                        fontSize: 11,
                                                                                                        fontWeight: 'bold',
                                                                                                        color: '#856404',
                                                                                                        backgroundColor: '#fff3cd',
                                                                                                        padding: '2px 5px',
                                                                                                        borderRadius: 5
                                                                                                    }}
                                                                                                >
																								En curso <br />
                                                                                                    <span
                                                                                                        style={{
                                                                                                            fontSize: 10,
                                                                                                            color: bottomColor
                                                                                                        }}
                                                                                                    >
                                                                                                        {bottomText}
                                                                                                    </span>
                                                                                                </p>
                                                                                            )
                                                                                        }
                                                                                        if (element.progress === 100) {
                                                                                            return (
                                                                                                <p
                                                                                                    style={{
                                                                                                        fontSize: 11,
                                                                                                        fontWeight: 'bold',
                                                                                                        color: '#155724',
                                                                                                        backgroundColor: '#d4edda',
                                                                                                        padding: '2px 5px',
                                                                                                        borderRadius: 5
                                                                                                    }}
                                                                                                >
																								Listo <br />
                                                                                                    <span
                                                                                                        style={{
                                                                                                            fontSize: 10,
                                                                                                            color: bottomColor
                                                                                                        }}
                                                                                                    >
                                                                                                        {bottomText}
                                                                                                    </span>
                                                                                                </p>
                                                                                            )
                                                                                        }
                                                                                        return (
                                                                                            <p
                                                                                                style={{
                                                                                                    fontSize: 11,
                                                                                                    color: '#666'
                                                                                                }}
                                                                                            >
																							Disponible
                                                                                                {isDownloaded && (
                                                                                                    <>
                                                                                                        <br />
                                                                                                        <span
                                                                                                            style={{
                                                                                                                fontSize: 10,
                                                                                                                color: bottomColor,
                                                                                                                fontWeight: 'bold'
                                                                                                            }}
                                                                                                        >
                                                                                                            {bottomText}
                                                                                                        </span>
                                                                                                    </>
                                                                                                )}
                                                                                            </p>
                                                                                        )
                                                                                    })()}
                                                                                </div>
                                                                            </Grid>
                                                                        </Hidden>
                                                                        <Hidden mdDown>
                                                                            <Grid
                                                                                item
                                                                                xl={'auto'}
                                                                                lg={'auto'}
                                                                                md={'auto'}
                                                                                sm={'auto'}
                                                                                xs={'auto'}
                                                                            >
                                                                                <div
                                                                                    style={{
                                                                                        width: '8%',
                                                                                        textAlign: 'center'
                                                                                    }}
                                                                                >
                                                                                    {element.hasTechnicalDocs ? (
                                                                                        <span
                                                                                            style={{
                                                                                                fontSize: 11,
                                                                                                fontWeight: 'bold',
                                                                                                color: '#155724',
                                                                                                padding: '4px 8px',
                                                                                                borderRadius: 5
                                                                                            }}
                                                                                        >
																						Sí
                                                                                        </span>
                                                                                    ) : (
                                                                                        <span
                                                                                            style={{
                                                                                                fontSize: 11,
                                                                                                color: '#721c24',
                                                                                                padding: '4px 8px',
                                                                                                borderRadius: 5
                                                                                            }}
                                                                                        >
																						No
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            </Grid>
                                                                        </Hidden>
                                                                        <Hidden mdUp>
                                                                            <Divider />
                                                                        </Hidden>
                                                                        <Grid
                                                                            item
                                                                            xl={1}
                                                                            lg={1}
                                                                            md={1}
                                                                            sm={12}
                                                                            xs={12}
                                                                        >
                                                                            <Hidden mdUp>
                                                                                <div
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        textAlign: 'center',
                                                                                        paddingRight: 0
                                                                                    }}
                                                                                >
                                                                                    <IconButton
                                                                                        onClick={() => {
                                                                                            handleReportAction(element)
                                                                                        }}
                                                                                        color="primary"
                                                                                    >
                                                                                        <p style={{ margin: 0 }}>
                                                                                            {element.ejecuciones?.some(
                                                                                                (e) =>
                                                                                                    (
                                                                                                        e.userId?._id || e.userId
                                                                                                    )?.toString() ===
																									userData?._id &&
																								e.termino === null
                                                                                            ) ? (
                                                                                                    element.readyToSend ? (
                                                                                                        'Listo a enviar'
                                                                                                    ) : (
                                                                                                        <FontAwesomeIcon icon={faPen} />
                                                                                                    )
                                                                                                ) : !isOperator &&
																							element.level &&
																							element.level > 0 ? (
                                                                                                        'Ver'
                                                                                                    ) : element.state ===
																								'En proceso' &&
																							(isUniversalInspector ||
																								isUniversalChief ||
																								admin ||
																								isSuperAdmin ||
																								(element.usersAssigned &&
																									element.usersAssigned.some(
																									    (user) =>
																									        (
																									            user._id || user
																									        )?.toString() ===
																											userData?._id
																									))) ? (
                                                                                                            <FontAwesomeIcon icon={faPen} />
                                                                                                        ) : (
                                                                                                            <FontAwesomeIcon icon={faEye} />
                                                                                                        )}
                                                                                        </p>
                                                                                    </IconButton>
                                                                                </div>
                                                                            </Hidden>
                                                                            <Hidden mdDown>
                                                                                <div
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        textAlign: 'center',
                                                                                        paddingRight: 0
                                                                                    }}
                                                                                >
                                                                                    <IconButton
                                                                                        onClick={() => {
                                                                                            handleReportAction(element)
                                                                                        }}
                                                                                        color="primary"
                                                                                    >
                                                                                        <p style={{ margin: 0 }}>
                                                                                            {element.ejecuciones?.some(
                                                                                                (e) =>
                                                                                                    (
                                                                                                        e.userId?._id || e.userId
                                                                                                    )?.toString() ===
																									userData?._id &&
																								e.termino === null
                                                                                            ) ? (
                                                                                                    element.readyToSend ? (
                                                                                                        'Listo a enviar'
                                                                                                    ) : (
                                                                                                        <FontAwesomeIcon icon={faPen} />
                                                                                                    )
                                                                                                ) : !isOperator &&
																							element.level &&
																							element.level > 0 ? (
                                                                                                        'Ver'
                                                                                                    ) : element.state ===
																								'En proceso' &&
																							(isUniversalInspector ||
																								isUniversalChief ||
																								admin ||
																								isSuperAdmin ||
																								(element.usersAssigned &&
																									element.usersAssigned.some(
																									    (user) =>
																									        (
																									            user._id || user
																									        )?.toString() ===
																											userData?._id
																									))) ? (
                                                                                                            <FontAwesomeIcon icon={faPen} />
                                                                                                        ) : (
                                                                                                            <FontAwesomeIcon icon={faEye} />
                                                                                                        )}
                                                                                        </p>
                                                                                    </IconButton>
                                                                                </div>
                                                                            </Hidden>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Hidden>
                                                                <Hidden mdDown>
                                                                    <div style={{ display: 'flex', width: '100%', alignItems: 'center', padding: '8px 0px' }}>
                                                                        <div style={{ width: '4%', textAlign: 'center' }}>
                                                                            <p style={{ fontSize: 11, margin: 0 }}>
                                                                                {element.newIdIndex ? element.newIdIndex : element.idIndex}
                                                                            </p>
                                                                        </div>
                                                                        <div style={{ width: '5%', textAlign: 'center' }}>
                                                                            <p style={{ fontSize: 11, margin: 0 }}>
                                                                                {element._guide}
                                                                            </p>
                                                                        </div>
                                                                        <div style={{ width: '6%', textAlign: 'center' }}>
                                                                            <p style={{ fontSize: 11, margin: 0 }}>
                                                                                {element.sapId}
                                                                            </p>
                                                                        </div>
                                                                        <div style={{ width: '9%', textAlign: 'center' }}>
                                                                            <p style={{ fontSize: 11, margin: 0 }}>
                                                                                {renderDateWithBreak(element.datePrev)}
                                                                            </p>
                                                                        </div>
                                                                        <div style={{ width: '9%', textAlign: 'center' }}>
                                                                            <p style={{ fontSize: 11, margin: 0 }}>
                                                                                {renderDateWithBreak(element.dateInit)}
                                                                            </p>
                                                                        </div>
                                                                        <div style={{ width: '9%', textAlign: 'center' }}>
                                                                            <p style={{ fontSize: 11, margin: 0 }}>
                                                                                {renderDateWithBreak(element.endPrev)}
                                                                            </p>
                                                                        </div>
                                                                        <div style={{ width: '9%', textAlign: 'center' }}>
                                                                            <p style={{ fontSize: 11, margin: 0 }}>
                                                                                {renderDateWithBreak(element.endReport)}
                                                                            </p>
                                                                        </div>
                                                                        <div style={{ width: '10%', textAlign: 'center' }}>
                                                                            <p style={{ fontSize: 11, margin: 0 }}>
                                                                                {renderFlotaWithBreak(element)}
                                                                            </p>
                                                                        </div>
                                                                        <div style={{ width: '8%', textAlign: 'center' }}>
                                                                            <p style={{ fontSize: 11, margin: 0 }}>
                                                                                {element.progress ? `${element.progress}%` : 'S/I'}
                                                                            </p>
                                                                        </div>
                                                                        <div style={{ width: '8%', textAlign: 'center' }}>
                                                                            <p style={{ fontSize: 11, margin: 0 }}>
                                                                                {element.maquina && element.maquina.equ}
                                                                            </p>
                                                                        </div>
                                                                        <div style={{ width: '8%', textAlign: 'center' }}>
                                                                            {(() => {
                                                                                const isDownloaded = !!element.tieneEjecucionEnDispositivo
                                                                                const hasOngoing = element.ejecuciones && element.ejecuciones.some(
                                                                                    (ej) => (ej.userId?._id || ej.userId)?.toString() === userData?._id && ej.inicio && ej.termino === null
                                                                                )
                                                                                const bottomText = isDownloaded ? 'Descargada' : 'Disponible'
                                                                                const bottomColor = isDownloaded ? '#4caf50' : '#856404'

                                                                                if (hasOngoing) {
                                                                                    return (
                                                                                        <p style={{ fontSize: 11, fontWeight: 'bold', color: '#856404', backgroundColor: '#fff3cd', padding: '2px 5px', borderRadius: 5, margin: 0 }}>
																							En curso <br />
                                                                                            <span style={{ fontSize: 10, color: bottomColor }}>{bottomText}</span>
                                                                                        </p>
                                                                                    )
                                                                                }
                                                                                if (element.progress === 100) {
                                                                                    return (
                                                                                        <p style={{ fontSize: 11, fontWeight: 'bold', color: '#155724', backgroundColor: '#d4edda', padding: '2px 5px', borderRadius: 5, margin: 0 }}>
																							Listo <br />
                                                                                            <span style={{ fontSize: 10, color: bottomColor }}>{bottomText}</span>
                                                                                        </p>
                                                                                    )
                                                                                }
                                                                                return (
                                                                                    <p style={{ fontSize: 11, color: '#666', margin: 0 }}>
																						Disponible
                                                                                        {isDownloaded && (
                                                                                            <>
                                                                                                <br />
                                                                                                <span style={{ fontSize: 10, color: bottomColor, fontWeight: 'bold' }}>{bottomText}</span>
                                                                                            </>
                                                                                        )}
                                                                                    </p>
                                                                                )
                                                                            })()}
                                                                        </div>
                                                                        <div style={{ width: '8%', textAlign: 'center' }}>
                                                                            {element.hasTechnicalDocs ? (
                                                                                <span style={{ fontSize: 11, fontWeight: 'bold', color: '#155724' }}>Sí</span>
                                                                            ) : (
                                                                                <span style={{ fontSize: 11, color: '#721c24' }}>No</span>
                                                                            )}
                                                                        </div>
                                                                        <div style={{ width: '7%', textAlign: 'center' }}>
                                                                            <IconButton
                                                                                onClick={() => {
                                                                                    handleReportAction(element)
                                                                                }}
                                                                                color="primary"
                                                                            >
                                                                                <p style={{ margin: 0, fontSize: 11 }}>
                                                                                    {element.ejecuciones?.some(
                                                                                        (e) => (e.userId?._id || e.userId)?.toString() === userData?._id && e.termino === null
                                                                                    ) ? (
                                                                                            element.readyToSend ? 'Listo a enviar' : <FontAwesomeIcon icon={faPen} />
                                                                                        ) : !isOperator && element.level && element.level > 0 ? (
                                                                                            'Ver'
                                                                                        ) : element.state === 'En proceso' && (
                                                                                            isUniversalInspector || isUniversalChief || admin || isSuperAdmin || (
                                                                                                element.usersAssigned && element.usersAssigned.some(
                                                                                                    (user) => (user._id || user)?.toString() === userData?._id
                                                                                                )
                                                                                            )
                                                                                        ) ? (
                                                                                                <FontAwesomeIcon icon={faPen} />
                                                                                            ) : (
                                                                                                <FontAwesomeIcon icon={faEye} />
                                                                                            )}
                                                                                </p>
                                                                            </IconButton>
                                                                        </div>
                                                                    </div>
                                                                </Hidden>
                                                            </div>
                                                        )
                                                    })}
                                                </Grid>
                                            )
                                        )}
                                    </>
                                )}
                                <Grid>
                                    {!showList && (
                                        <div
                                            style={{
                                                width: '100%',
                                                textAlign: 'center',
                                                height: 100
                                            }}
                                        >
                                            <CircularProgress size={50} />
                                        </div>
                                    )}
                                </Grid>
                            </div>
                        </Grid>
                    </Card>
                </Grid>
            </Grid>
            {openPrepareModal && (
                <BulkActionDialog
                    open={openPrepareModal}
                    onClose={() => setOpenPrepareModal(false)}
                    onConfirm={handlePrepareOts}
                    reports={Array.from(selectedReports.values())}
                    onRemoveReport={handleRemoveSelectedReport}
                    actionType="autoasignar"
                />
            )}
            <GenerationStatusModal />
        </Box>
    )
}

export default ActivitiesPage
